import React from 'react';

import { useSirenService } from '@europrocurement/l2d-domain';
import { useParcoursFormalite } from '@europrocurement/l2d-modules/modules/ParcoursFormalite/provider';
import { useCurrentDossierCtx } from '@europrocurement/l2d-modules/modules/Dossiers/providers/CurrentDossierProvider';
import { type customItemJsonProps } from '../customItemRenderer';

const SirenRne: React.FunctionComponent<customItemJsonProps> = function ({ formContext, props }) {
    formContext.watch(props.name);

    const { sirenApi } = useSirenService();

    const { currentSousClient } = useParcoursFormalite();

    const { dossier } = useCurrentDossierCtx();

    const [siren, setSiren] = React.useState<string>(currentSousClient?.siren || '902244870');
    const [lastSiren, setLastSiren] = React.useState<string>('999999999');

    React.useEffect(() => {
        if (currentSousClient && currentSousClient.siren && siren !== currentSousClient.siren) {
            if (currentSousClient.siren !== '') {
                setSiren(currentSousClient.siren);
            }
        } else if (dossier && dossier.clientOpereSiren) {
            setSiren(dossier.clientOpereSiren);
        }
    }, [currentSousClient, siren, dossier]);

    // React.useEffect(() => {
    //     console.log('currentSousClient', currentSousClient);
    // }, [currentSousClient]);

    // React.useEffect(() => {
    //     console.log('dossier', dossier);
    // }, [dossier]);

    // React.useEffect(() => {
    //     console.log('siren', siren);
    // }, [siren]);
    // React.useEffect(() => {
    //     console.log('lastSiren', lastSiren);
    // }, [lastSiren]);

    // Si siren change => on appel l'api siren pour récupérer les data et les mettre dans le formContext
    React.useEffect(() => {
        // console.log('newSiren : ', siren);
        if (siren !== '' && lastSiren !== siren) {
            sirenApi
                .apiRcsSirenGet({
                    siren,
                })
                .then((res) => {
                    setLastSiren(siren);
                    // console.log('FORM VALUES', formContext.getValues());
                    // console.log('siren data', res.data);

                    const denomination = res.data?.denomination ?? '';
                    formContext.setValue(
                        'personneMorale.identite.description.currentRneDenomination',
                        denomination,
                    );

                    // Récup objet social depuis l’établissement principal
                    const principal = res.data?.etablissements?.principal?.[0];

                    // safe : prendre l'activité "principale" si elle existe, sinon la 1ère
                    const activitePrincipale =
                        principal?.aActivite?.find((a) => a.indicateurPrincipal === true) ??
                        principal?.aActivite?.[0];

                    const objet = activitePrincipale?.descriptionDetaillee ?? '';
                    formContext.setValue('personneMorale.identite.description.objet', objet);

                    const capital = res.data?.capital ?? '';
                    formContext.setValue('custom_l2d.currentRneCapital', capital);

                    if (res.data.composition && res.data.composition.structure) {
                        const { structure } = res.data.composition;
                        // console.log('Structure : ', structure);
                        const dirigeants = structure.map((structureItem) => ({
                            gestionDirigeant: {
                                custom_l2d: {
                                    typePersonne: structureItem.denomination
                                        ? { value: 2, label: 'Personne morale' }
                                        : { value: 1, label: 'Personne physique' },
                                },
                                roleEntreprise: {
                                    value: structureItem.roleEntreprise,
                                    label: structureItem.libelleRoleEntreprise,
                                },
                                individu: {
                                    descriptionPersonne: {
                                        nom: structureItem.nom,
                                        nomUsage: structureItem.nomUsage,
                                        prenoms: structureItem.prenoms,
                                    },
                                },
                                entreprise: {
                                    denomination: structureItem.denomination,
                                },
                            },
                        }));
                        formContext.setValue('gestion_dirigeant', dirigeants);
                    }

                    // console.log('keys etablissements :', Object.keys(res.data.etablissements ?? {}));
                    // console.log('etablissements raw :', res.data.etablissements);

                    if (res.data.etablissements && res.data.etablissements.autres) {
                        const { autres } = res.data.etablissements;

                        // console.log('autres brut (avant filtre) :', autres);
                        // console.log('autres length :', autres.length);
                        // console.log('actifs :', autres.filter(e => e.actif === true));

                        // console.log('Etablissements autres (secondaires) : ', autres);
                        const etablissements = autres
                            .filter((autresItem) => autresItem.actif === true)
                            .map((autresItem) => ({
                                gestionFermetureEtablissement: {
                                    custom_l2d: {
                                        siret: autresItem.siret,
                                    },
                                    personneMorale: {
                                        autresEtablissements: {
                                            adresse: {
                                                codePostal: autresItem.address?.codePostal,
                                                commune: autresItem.address?.commune,
                                                voie: autresItem.address?.adresse,
                                            },
                                        },
                                    },
                                },
                            }));

                        formContext.setValue('gestion_fermeture_etablissement', etablissements);
                    }
                });
        }
    }, [siren, sirenApi, formContext, lastSiren]);

    return null;
};

export default SirenRne;
